import { useQuery } from '@tanstack/react-query';

import SearchService from '~/services/SearchService';

export const resolveOfferIdQueryKeys = {
  all: ['resolveOfferId'] as const,
  byName: (name: string) => [...resolveOfferIdQueryKeys.all, name] as const,
};

export function useResolveOfferId(propertyName: string | null) {
  return useQuery({
    queryKey: resolveOfferIdQueryKeys.byName(propertyName ?? ''),
    queryFn: async () => {
      const { result } = await SearchService.typeahead(propertyName, {
        type: ['le_property'],
        brand: 'luxuryescapes',
        region: 'AU',
        limit: 1,
        priority: 'current',
      });
      return result?.[0]?.offerId ?? null;
    },
    enabled: !!propertyName,
  });
}
